class LoadMoreButton extends HTMLElement {
  #gridObserver = null;

  connectedCallback() {
    const resultsList = this.closest('results-list');
    if (!resultsList) return;

    const total = parseInt(this.dataset.total || '0', 10);
    const label = this.dataset.label || 'products';
    const countEl = this.querySelector('[data-load-more-count]');
    const grid = resultsList.querySelector('[ref="grid"]');
    const btn = this.querySelector('.load-more-bar__btn');

    if (!grid) return;

    if (btn) {
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        await resultsList.renderNextPage();
        btn.disabled = false;
      });
    }

    const syncState = (loaded) => {
      if (countEl) {
        countEl.textContent = `Showing 1–${loaded} of ${total} ${label}`;
      }
      if (loaded >= total) {
        this.setAttribute('data-exhausted', '');
        this.#gridObserver?.disconnect();
        this.#gridObserver = null;
      }
    };

    this.#gridObserver = new MutationObserver(() => {
      const loaded = grid.querySelectorAll(':scope > [ref="cards[]"]').length;
      syncState(loaded);
    });

    this.#gridObserver.observe(grid, { childList: true });

    // Initial check: hide button if all products are already visible on first render
    syncState(grid.querySelectorAll(':scope > [ref="cards[]"]').length);
  }

  disconnectedCallback() {
    this.#gridObserver?.disconnect();
  }
}

if (!customElements.get('load-more-button')) {
  customElements.define('load-more-button', LoadMoreButton);
}
